<main class="container p-0" id="masterPage">
  <section class="p-0 w-100">
    <div class="row m-0">
      <div class="col col-12 borderNone" [class.no-padding]="isNoPaddingRoute()">
        <router-outlet></router-outlet>
      </div>
    </div>
  </section>
</main>
